// extracted by mini-css-extract-plugin
export default {"sonarTableChart":"SonarTableChart_sonarTableChart__gxo-p","generalInfoCVChart":"SonarTableChart_generalInfoCVChart__g7Bz-"};